import { AxiosError } from 'axios';
import classNames from 'classnames';
import { Button } from 'yoso';
import { BaseError } from '~/components/Error/BaseError';
import { ErrorMessage } from '~/components/Error/Message/v2/ErrorMessage';
import { T, t } from '~/components/I18n';
import { Siren } from '~/components/Icon/Siren';
import { regularFormat } from '~/components/Util';
import styles from './MaintenanceErrorMessage.module.scss';
const DOSI_URL = import.meta.env.VITE_DOSI_URL;

export type MaintenanceErrorResponse = {
  responseData: { startAt: Date; endAt: Date };
};
export type MaintenanceErrorMessageProps = {
  className?: string;
  error: BaseError<AxiosError<MaintenanceErrorResponse>>;
};

export const MaintenanceErrorMessage = ({ className, error }: MaintenanceErrorMessageProps) => {
  const { startAt, endAt } = error.payload?.response?.data.responseData || {};
  return (
    <ErrorMessage
      className={classNames(styles.root, className)}
      icon={<Siren width="100" height="100" alt={t('citizen_maintenance_title')} />}
      title={t('citizen_maintenance_title')}
      description={
        <>
          <T name="citizen_maintenance_desc" />
          <span className={styles.period}>
            {regularFormat(startAt, { format: 'PP p' })} ~{' '}
            {regularFormat(endAt, { format: 'PP p' })}
          </span>
        </>
      }>
      <Button as="a" href={DOSI_URL} size="large" color="primary">
        <T name="citizen_maintenance_dosihome" />
      </Button>
    </ErrorMessage>
  );
};
